/** 意图视频三个 tab 共用的展示格式化。各写一份必然漂移出三种时间格式。 */

export function statusVariant(status) {
  switch (status) {
    case 'published':
      return 'success'
    case 'in_review':
      return 'warning'
    case 'rejected':
      return 'danger'
    default:
      throw new Error(`Unhandled intent video resource status: ${status}`)
  }
}

export function statusLabel(t, status) {
  return t(`visualGameAdmin.intentVideo.status.${status}`)
}

export function queueStatusVariant(status) {
  switch (status) {
    case 'pending':
      return 'neutral'
    case 'prompting':
    case 'rendering':
      return 'info'
    case 'prompt_ready':
      return 'warning'
    case 'done':
      return 'success'
    case 'failed':
      return 'danger'
    default:
      throw new Error(`Unhandled intent video request status: ${status}`)
  }
}

export function queueStatusLabel(t, status) {
  return t(`visualGameAdmin.intentVideo.queueStatus.${status}`)
}

export function formatDate(value) {
  return value === null || value === undefined ? '-' : new Date(value).toLocaleString()
}

export function formatMs(value) {
  if (value === null || value === undefined) return '-'
  return value < 1000 ? `${value}ms` : `${(value / 1000).toFixed(1)}s`
}

export function formatBytes(value) {
  if (value === null || value === undefined) return '-'
  if (value < 1024) return `${value} B`
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(0)} KB`
  return `${(value / 1024 / 1024).toFixed(1)} MB`
}

/** 相似度按阈值上色：0.75 是召回线，低于它的候选不会被播出。 */
export function similarityColor(value) {
  if (value >= 0.85) return 'var(--drama-color-success)'
  if (value >= 0.75) return 'var(--drama-color-warning)'
  return 'var(--drama-color-danger)'
}

/** Pagination 的 summary 是拼好的字符串——@drama/ui 不认识 i18n，措辞归页面。 */
export function pageSummary(t, { loaded, hasNext }) {
  return hasNext
    ? t('visualGameAdmin.intentVideo.pager.loadedMore', { n: loaded })
    : t('visualGameAdmin.intentVideo.pager.loadedAll', { n: loaded })
}
